import { NOTIFY_TYPES, NOTIFY_RESP } from '@/common/constants/message';
import { calcUserName } from '_lib/CalcUserInfo';

export function getMsgDesc(msg) {
  let str = ''
  switch (msg.notify_type) {
    case NOTIFY_TYPES.addFriend:
      str = `${msg.nickname} 申请加为好友`
      break
    case NOTIFY_TYPES.respFriend:
      str = '我: 申请加为好友'
      break
    case NOTIFY_TYPES.respInvite:
      str = `${msg.nickname} 邀请你进入 ${msg.room_name}${msg.channel_name ? ' / ' + msg.channel_name : ''}`
      break
    case NOTIFY_TYPES.invite:
      str = `我: 邀请你进入 ${msg.room_name}${msg.channel_name ? ' / ' + msg.channel_name : ''}`
      break
    case NOTIFY_TYPES.apply_enter_room:
      if (msg.resp === NOTIFY_RESP.APPLT) {
        str = '已同意你加入房间'
      } else {
        str = `我: 申请加入房间 ${msg.room_name}`
      }
      break
    case NOTIFY_TYPES.receive_apply_enter_room:
      str = `申请加入房间 ${msg.room_name}`
      break
    case NOTIFY_TYPES.request_join_room:
      if (msg.resp === NOTIFY_RESP.APPLT) {
        str = '已同意你加入房间'
      } else {
        str = `我: 申请加入房间 ${msg.room_name}`
      }
      break
    case NOTIFY_TYPES.receive_request_join_room:
      str = `申请加入房间 ${msg.room_name}${msg.reason ? '，申请理由：' + msg.reason : ''}`
      break
    case NOTIFY_TYPES.feedback:
      str = '小黑妹回复了你的用户反馈'
      break
    case NOTIFY_TYPES.promise:
      const cancel_text = `${msg?.nickname}已取消${getInviteStartTime(msg.begin_s)}的开黑`
      const invite_text = `${msg?.nickname}邀请你于${getInviteStartTime(msg.begin_s)}开黑`
      if (msg.hasOwnProperty('state')) {
        if (msg.state == NOTIFY_RESP.REJECT || msg.state == NOTIFY_RESP.DESTROYED) {
          str = cancel_text
        } else {
          str = invite_text
        }
      } else if (msg.hasOwnProperty('resp')) {
        if (msg.resp == NOTIFY_RESP.DESTROYED) {
          str = cancel_text
        } else {
          str = invite_text
        }
      }
      break
    case NOTIFY_TYPES.promise_time: //开黑时间提醒
      str = msg.remaining > 0 ? `5分钟后将开始${msg.title}，赶紧上号吧！`: `${msg.title}即将开始，赶紧上号吧！`
      break;
    case NOTIFY_TYPES.system_notification:
      str = msg.content
      break;
    case NOTIFY_TYPES.team_push:
      str = msg.content
      break;
    case NOTIFY_TYPES.room_anc_at:
      str = msg.content
      break;
    case NOTIFY_TYPES.chat_group_universal_apply:
      const applyUsername = msg.tip_actions?.actions?.apply_user?.text
      str = `${applyUsername} 申请加入群聊`
      break;
    default:
      str = msg.msg
      break
  }
  return str
}
export function getInviteStartTime(timestamp) {
  let date_start = new Date(timestamp * 1000)
  return `${date_start.getMonth()+1}月${date_start.getDate()}日`
}
export function getMsgNickname(msg) {
  if (msg.notify_type === NOTIFY_TYPES.feedback) {
    return '小黑妹'
  } else if(msg.notify_type === NOTIFY_TYPES.promise_time) {
    return '开黑邀约'
  } else {
    return calcUserName(msg)
  }
}
export function getRespText(notify_type, resp, show_type = 'message') {
  let str = ''
  switch (notify_type) {
    case NOTIFY_TYPES.invite:
      str = resp === NOTIFY_RESP.APPLT ? '已接受' : '等待验证'
      break
    case NOTIFY_TYPES.feedback:
      str = resp === NOTIFY_RESP.APPLT ? '查看' : resp === NOTIFY_RESP.REJECT ? '已忽略' : '等待处理'
      break
    case NOTIFY_TYPES.promise:
      if (resp === NOTIFY_RESP.APPLT) {
        str = '已接受'
      } else if (resp === NOTIFY_RESP.REJECT) {
        str = '已拒绝'
      } else {
        if (show_type === 'notice') {
          str = '已取消'
        } else {
          str = '已过期'
        }
      }
      break
    case NOTIFY_TYPES.promise_time:
      str = resp === NOTIFY_RESP.REJECT ? '已忽略' : '已过期'
      break
    case NOTIFY_TYPES.system_notification:
      str = ''
      break
    case NOTIFY_TYPES.apply_enter_room:
      if (resp === NOTIFY_RESP.APPLY_RESP) {
        str = '已接受'
      } else if (resp === NOTIFY_RESP.REJECT_RESP) {
        str = '已忽略'
      } else {
        str = '等待验证'
      }
      break
    case NOTIFY_TYPES.request_join_room: 
      if(resp === NOTIFY_RESP.APPLY_RESP) {
        str = '已接受'
      } else if (resp === NOTIFY_RESP.REJECT_RESP) {
        str = '已忽略'
      }
      break
    case NOTIFY_TYPES.room_anc_at:
      str = resp === NOTIFY_RESP.APPLT ? '已查看' : '已忽略'
      break
    case NOTIFY_TYPES.chat_group_universal_apply: 
      str = resp === NOTIFY_RESP.APPLT ? '已前往审批' : resp === NOTIFY_RESP.REJECT ? '已忽略' : '等待验证'
      break
    default:
      str = resp === NOTIFY_RESP.APPLT ? '已接受' : resp === NOTIFY_RESP.REJECT ? '已忽略' : '等待验证'
      break
  }
  return str
}